import { render, staticRenderFns } from "./article-view.vue?vue&type=template&id=baaced9e&"
import script from "./article-view.vue?vue&type=script&lang=js&"
export * from "./article-view.vue?vue&type=script&lang=js&"
import style0 from "./article-view.vue?vue&type=style&index=0&id=baaced9e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports